<div>
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">
        <button type="button" class="btn btn-link" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed"
        aria-controls="collapseExample">
        Wap Us!
      </button>
      </h5>
    </div>
  </div>
</div>
<div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
  <div class="card">
    <div class="card-body">
      Encargado de solucionar fallos en el sistema además de crear diversas soluciones para los requerimientos bien sea, creando nueva lógica de programación (crear nuevos servicios, crear nuevos componentes, transferir información entre dichos componentes) o estudiar la lógica existente, consumiendo una Rest API para procesar los datos en la vista del cliente y procesar los datos que serán almacenados, usando Angular como Framework Javascript y Angular Material combinado con Bootstrap para el diseño. Utilizando un sistema de control de versiones (Bit Bucket) para el optimo manejo del proyecto con los otros desarrolladores. Empleando apis de terceros tales como Google Maps y Paypal
    </div>
  </div>
</div>

<div class="mt-5">
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">
        <button type="button" class="btn btn-link" (click)="collapseF.toggle()" [attr.aria-expanded]="!isCollapsedFlexy"
        aria-controls="collapseExample">
        Flexy Store
      </button>
      </h5>
    </div>
  </div>
</div>
<div class="mb-5" #collapseF="ngbCollapse" [(ngbCollapse)]="isCollapsedFlexy">
  <div class="card">
    <div class="card-body">
      Encargado de solucionar fallos en el sistema además de crear diversas soluciones para los requerimientos bien sea, creando nueva lógica de programación (crear nuevos servicios, crear nuevos componentes, transferir información entre dichos componentes) o estudiar la lógica existente, consumiendo una Rest API para procesar los datos en la vista del cliente y procesar los datos que serán almacenados, usando Angular como Framework Javascript y Angular Material combinado con Bootstrap para el diseño. Utilizando un sistema de control de versiones (Bit Bucket) para el optimo manejo del proyecto con los otros desarrolladores. Empleando apis de terceros tales como Google Maps y Paypal
    </div>
  </div>
</div>
